import { render, staticRenderFns } from "./SurveyForms.vue?vue&type=template&id=656fa3ac"
import script from "./SurveyForms.vue?vue&type=script&lang=ts"
export * from "./SurveyForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports